import { useLayoutEffect, useRef, useState } from 'react'

const RECT_BASE = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
}

const rectUpdater = (newRect) => (oldRect) => {
  if (
    oldRect.x !== newRect.x ||
    oldRect.y !== newRect.y ||
    oldRect.width !== newRect.width ||
    oldRect.height !== newRect.height
  ) {
    return newRect
  }
  // Return same object reference to prevent infinity renders
  return oldRect
}

/**
 * Get a DOMRect state of an element based on a ref
 * Work only inside SVG context
 *
 * @param {Number} interval optional watch interval (default 500ms)
 * @returns {[RefObject, DOMRect]}
 */
const usePosition = () => {
  // Creates a ref instance to add to DOM
  const ref = useRef(null)
  // Rect as state will be used to watch sizes and positions
  const [rect, setRect] = useState({ ...RECT_BASE })

  useLayoutEffect(() => {
    try {
      const newRect = ref.current?.getBBox() ?? { ...RECT_BASE }
      setRect(rectUpdater(newRect))

      // Check again after a delay to make sure all refs are calculated
      setTimeout(() => {
        const newRect = ref.current?.getBBox() ?? { ...RECT_BASE }
        setRect(rectUpdater(newRect))
      }, 10)
    } catch (error) {
      if (error instanceof TypeError) {
        console.error(
          "usePosition error. \n\nYou most likely added `ref` or `Rect` to an element that isn't a SVG's child.\n\n",
          error
        )
      } else {
        throw new Error(error)
      }
    }
  })

  return [ref, rect]
}

export default usePosition
